import { combineReducers } from '@reduxjs/toolkit';
import createSystemRoleReducer from './create-system-role';
import deleteSystemRoleReducer from './delete-system-role';
import getSystemRoleListReducer from './get-system-role-list';
import updateSystemRoleReducer from './update-system-role';

const systemRoleReducer = combineReducers({
  createSystemRole: createSystemRoleReducer,
  deleteSystemRole: deleteSystemRoleReducer,
  getSystemRoleList: getSystemRoleListReducer,
  updateSystemRole: updateSystemRoleReducer
});

export default systemRoleReducer;